/* Babyknuddel Shopify-Theme: Schubladen, Warenkorb, Produktseite, Suche. Kein Framework. */
(() => {
  const $ = (s, w = document) => w.querySelector(s);
  const $$ = (s, w = document) => [...w.querySelectorAll(s)];
  const BF = window.BF || {};
  const root = (BF.root || '/').replace(/\/$/, '');
  // Texte in der Sprache des Besuchers (aus layout/theme.liquid)
  const T = (() => { const roh = window.BK_T || {}, d = document.createElement('textarea'), o = {}; Object.keys(roh).forEach((k) => { d.innerHTML = roh[k]; o[k] = d.value; }); return o; })();
  const tx = (k, w) => (T[k] || '').replace('%s', w);

  // Geld nach Shop-Format
  function geld(cents) {
    const f = BF.geld || '{{amount_with_comma_separator}} €';
    const n = (cents / 100);
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    const art = m ? m[1] : 'amount';
    let s;
    if (art === 'amount_no_decimals') s = Math.round(n).toLocaleString('en-US');
    else if (art === 'amount_with_comma_separator') s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (art === 'amount_no_decimals_with_comma_separator') s = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (art === 'amount_with_space_separator') s = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    else s = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  const lies = (k, leer) => { try { return JSON.parse(localStorage.getItem(k)) || leer; } catch (e) { return leer; } };
  const schreib = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());

  // Blätter (Menü, Suche, Korb)
  const blaetter = ['menue', 'suche', 'korb'];
  function auf(name) {
    blaetter.forEach((b) => { const el = $('#' + b); if (el) el.hidden = b !== name; });
    const sch = $('#schleier'); if (sch) sch.hidden = name !== 'korb';
    document.body.classList.add('blatt-offen');
    if (name === 'suche') { const f = $('#suche-feld'); if (f) { f.focus(); maleSuche(f.value); } }
  }
  function alleZu() {
    blaetter.forEach((b) => { const el = $('#' + b); if (el) el.hidden = true; });
    const sch = $('#schleier'); if (sch) sch.hidden = true;
    document.body.classList.remove('blatt-offen');
  }

  // Warenkorb
  let korb = null, zuletztRein = 0, codeGemerkt = '', codeFehler = false;
  const zahlarten = () => { const t = $('#korb-zahlarten'); return t ? t.innerHTML : ''; };
  function zeigeZahl() {
    const z = $('#korb-zahl'); if (!z || !korb) return;
    z.textContent = korb.item_count; z.hidden = korb.item_count === 0;
  }
  function codeAusKorb() { const d = (korb && korb.discount_codes || []).find((x) => x.applicable); codeGemerkt = d ? String(d.code).toUpperCase() : ''; }
  async function ladeKorb() { korb = await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); codeAusKorb(); zeigeZahl(); return korb; }
  function dazuZeile(p) {
    const bild = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_220x220$1$2') : '';
    const einfach = p.variants && p.variants.length === 1 && p.available;
    return `<div class="dazu-zeile"><a href="${p.url}">${bild ? `<img src="${bild}" alt="" loading="lazy">` : ''}<span>${p.title}<b>${geld(p.price)}</b></span></a>${einfach ? `<button class="dazu-plus" type="button" data-rein="${p.variants[0].id}" aria-label="${p.title}: ${T.in_den_warenkorb}">+</button>` : `<a class="dazu-plus" href="${p.url}" aria-label="${p.title}: ${T.ansehen}">›</a>`}</div>`;
  }
  async function maleKorb() {
    const liste = $('#korb-liste'), fuss = $('#korb-fuss'), aside = $('#korb');
    if (!liste || !korb) return;
    const n = korb.item_count;
    $('#korb-titel').textContent = n ? `${T.warenkorb} · ${n} ${n === 1 ? T.teil : T.teile}` : T.warenkorb;
    if (!n) {
      liste.innerHTML = `<div class="korb-leer"><svg viewBox="0 0 120 70" aria-hidden="true"><circle cx="34" cy="44" r="22"/><circle cx="62" cy="30" r="28"/><circle cx="90" cy="46" r="20"/><rect x="34" y="42" width="56" height="24" rx="4"/></svg><p>${T.leer}</p><a class="knopf" href="${root}/collections/all">${T.zum_shop}</a></div>`;
      fuss.innerHTML = '';
      return;
    }
    const frei = +aside.dataset.versandfrei || 0, s = korb.items_subtotal_price, rest = Math.max(0, frei - s), proz = frei ? Math.min(100, Math.round(s / frei * 100)) : 100;
    liste.innerHTML = (frei ? `<div class="versandbalken ${rest ? '' : 'voll'}"><p>${rest ? tx('noch_bis_frei', geld(rest)) : T.frei_drin}</p><div class="balken"><i style="width:${proz}%"></i></div></div>` : '')
      + korb.items.map((it, i) => `<div class="posten${it.variant_id === zuletztRein ? ' neu-drin' : ''}">
          <a class="posten-bild" href="${it.url}">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_220x220$1$2')}" alt="">` : ''}</a>
          <div class="posten-text"><a href="${it.url}"><b>${it.product_title}</b></a>${it.variant_title && it.variant_title !== 'Default Title' ? `<em>${it.variant_title}</em>` : ''}<span class="einzel">${tx('je_stueck', geld(it.final_price))}</span>
            <div class="posten-unten"><div class="menge"><button type="button" data-zeile="${i + 1}" data-n="${it.quantity - 1}" aria-label="${T.weniger}">−</button><span>${it.quantity}</span><button type="button" data-zeile="${i + 1}" data-n="${it.quantity + 1}" aria-label="${T.mehr}">+</button></div><span class="zeile">${geld(it.final_line_price)}</span></div></div>
          <button class="weg" type="button" data-zeile="${i + 1}" data-n="0" aria-label="${it.product_title}: ${T.entfernen}">×</button></div>`).join('');
    const geschenk = aside.dataset.geschenk === 'true';
    liste.innerHTML += `<div class="korb-dazu" id="korb-dazu" hidden><b>${T.passt_dazu}</b><div class="mini-reihe" id="korb-dazu-reihe"></div></div>
      <div class="korb-extra">${geschenk ? `<label class="geschenk"><input type="checkbox" id="geschenk" ${korb.attributes && korb.attributes.Geschenk === 'ja' ? 'checked' : ''}> ${T.geschenk}</label>` : ''}
        ${codeGemerkt ? `<p class="code-an">${tx('code_an', codeGemerkt.replace(/[<>&"]/g, ''))} <button type="button" class="code-weg" data-code-weg>${T.entfernen}</button></p>` : `<form class="code" id="code-form"><input id="code-feld" placeholder="${T.rabattcode}" autocomplete="off" aria-label="${T.rabattcode}"><button type="submit">${T.merken}</button></form>${codeFehler ? `<p class="code-fehler">${T.code_falsch}</p>` : ''}`}</div>`;
    const rabatt = (korb.cart_level_discount_applications || []).reduce((a, d) => a + d.total_allocated_amount, 0);
    fuss.innerHTML = `<div class="summen"><div><span>${T.zwischensumme}</span><span>${geld(korb.items_subtotal_price)}</span></div>${rabatt ? `<div class="rabatt"><span>${T.rabatt}</span><span>− ${geld(rabatt)}</span></div>` : ''}<div><span>${T.versand}</span><span>${frei && !rest ? T.kostenlos : T.an_der_kasse}</span></div><div class="gesamt"><span>${T.gesamt}</span><span>${geld(korb.total_price)}</span></div></div>
      <small>${T.inkl_mwst}${frei && !rest ? '' : T.zzgl_versand}</small>
      <a class="knopf breit" id="kasse" href="${root}/checkout">${T.zur_kasse} · ${geld(korb.total_price)}</a>
      <a class="weiter" href="${root}/collections/all" data-zu>${T.weiter_einkaufen}</a>${zahlarten()}`;
    // Passt gut dazu: Empfehlungen zum ersten Teil
    try {
      const drin = new Set(korb.items.map((it) => it.product_id));
      const r = await fetch(`${BF.empfehlungen || root + '/recommendations/products'}?product_id=${korb.items[0].product_id}&limit=6&intent=related`, { headers: { Accept: 'application/json' } }).then((x) => x.json());
      const dazu = (r.products || []).filter((p) => !drin.has(p.id)).slice(0, 3);
      const box = $('#korb-dazu');
      if (dazu.length && box) { $('#korb-dazu-reihe').innerHTML = dazu.map(dazuZeile).join(''); box.hidden = false; }
    } catch (e) {}
  }
  // Rein in den Warenkorb: Bild fliegt zum Korb, Zahl springt hoch, nichts klappt auf
  const ruhig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function hupf() {
    const k = $('#korb-auf'), z = $('#korb-zahl');
    if (ruhig()) return;
    if (k && k.animate) k.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(.94)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'ease-out' });
    if (z && z.animate) z.animate([{ transform: 'scale(.4)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(.3,1.6,.5,1)' });
  }
  function setzeZahl(n) { const z = $('#korb-zahl'); if (z) { z.textContent = n; z.hidden = n === 0; } }
  function flieg(quelle) {
    const ziel = $('#korb-auf');
    if (!ziel || ruhig() || !document.body.animate) { hupf(); return; }
    const karte = quelle && quelle.closest('.karte, .dazu-zeile, .set-teil');
    let bild = karte ? $('img', karte) : null;
    if (!bild) bild = $$('.g-bild img')[gJetzt] || $('.g-bild img') || $('.produkt-bild img');
    const sichtbar = (r) => r.width > 0 && r.bottom > 60 && r.top < window.innerHeight;
    let a = bild ? bild.getBoundingClientRect() : null;
    if (!a || !sichtbar(a)) a = (quelle || ziel).getBoundingClientRect();
    const b = ziel.getBoundingClientRect();
    const g = Math.max(56, Math.min(a.width, a.height, 150));
    const x0 = a.left + a.width / 2 - g / 2, y0 = a.top + a.height / 2 - g / 2;
    const el = document.createElement('div');
    el.className = 'flug';
    el.style.cssText = `left:${x0}px;top:${y0}px;width:${g}px;height:${g}px;${bild ? `background-image:url("${bild.currentSrc || bild.src}")` : ''}`;
    document.body.appendChild(el);
    const dx = b.left + b.width / 2 - (x0 + g / 2), dy = b.top + b.height / 2 - (y0 + g / 2);
    const flug = el.animate([
      { transform: 'translate3d(0,0,0) scale(1)', opacity: 1 },
      { transform: `translate3d(${dx * .5}px,${dy * .5 - 50}px,0) scale(.6)`, opacity: 1, offset: .5 },
      { transform: `translate3d(${dx}px,${dy}px,0) scale(.14)`, opacity: .7 }
    ], { duration: 680, easing: 'cubic-bezier(.5,0,.3,1)' });
    flug.onfinish = () => { el.remove(); hupf(); };
    flug.oncancel = () => el.remove();
  }
  function knopfDrin(k) {
    if (!k) return;
    if (k.classList.contains('schnell')) { k.classList.add('drin'); setTimeout(() => k.classList.remove('drin'), 1400); return; }
    if (k.tagName !== 'BUTTON' || !T.im_korb) return;
    const alt = k.textContent; k.classList.add('drin'); k.textContent = '✓ ' + T.im_korb;
    setTimeout(() => { k.classList.remove('drin'); if (k.textContent === '✓ ' + T.im_korb) k.textContent = alt; }, 1600);
  }
  let hinweisTimer = null;
  function hinweis(text) {
    let h = $('#hinweis');
    if (!h) { h = document.createElement('div'); h.id = 'hinweis'; h.className = 'hinweis'; h.setAttribute('role', 'status'); document.body.appendChild(h); }
    h.textContent = text; h.classList.add('da'); clearTimeout(hinweisTimer); hinweisTimer = setTimeout(() => h.classList.remove('da'), 3200);
  }
  async function reinAlle(items, quelle) {
    const imKorb = quelle && quelle.closest('#korb');
    const n = items.reduce((a, x) => a + x.quantity, 0), vorher = korb ? korb.item_count : (+(($('#korb-zahl') || {}).textContent) || 0);
    if (!imKorb) { flieg(quelle); knopfDrin(quelle); setTimeout(() => setzeZahl(vorher + n), ruhig() ? 0 : 600); }
    let antwort = null;
    try {
      const r = await fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      antwort = await r.json(); if (!r.ok) throw antwort;
    } catch (fehler) {
      await ladeKorb().catch(() => {}); hinweis((fehler && (fehler.description || fehler.message)) || T.nicht_verfuegbar); return;
    }
    zuletztRein = items[0].id;
    await ladeKorb();
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    if (imKorb) await maleKorb();
  }
  const rein = (id, n = 1, quelle) => reinAlle([{ id: +id, quantity: n }], quelle);
  async function setze(zeile, n) { korb = await post(root + '/cart/change.js', { line: zeile, quantity: n }); zeigeZahl(); await maleKorb(); }

  // Produktseite
  const art = $('#produkt');
  let produkt = null, gAnzahl = 0, gJetzt = 0;
  function markiere(i) {
    gJetzt = i;
    const z = $('#g-zahl'); if (z) z.textContent = `${i + 1} / ${gAnzahl}`;
    $$('.g-klein button').forEach((b, n) => b.classList.toggle('an', n === i));
  }
  function zeigeBild(i, sofort) {
    const bahn = $('#g-bahn'); if (!bahn || !gAnzahl) return;
    i = (i + gAnzahl) % gAnzahl;
    bahn.scrollTo({ left: i * bahn.clientWidth, behavior: sofort ? 'auto' : 'smooth' });
    markiere(i);
  }
  function zeigeMedia(id) {
    if (!id) return;
    const idx = $$('.g-bild').findIndex((b) => b.dataset.mediaId === String(id));
    if (idx >= 0) zeigeBild(idx);
  }
  function wahl() {
    // gewählte Optionswerte je Position sammeln
    const werte = {};
    $$('.farben[data-option]').forEach((c) => { const a = $('.an', c); if (a) werte[c.dataset.option] = a.dataset.farbe; });
    $$('.groessen[data-option]').forEach((c) => { const a = $('.an', c); if (a) werte[c.dataset.option] = a.dataset.gr; });
    return werte;
  }
  function varianteSuchen() {
    if (!produkt) return null;
    const w = wahl();
    return produkt.variants.find((v) => [1, 2, 3].every((p) => !w[p] || v['option' + p] === w[p])) || null;
  }
  function zeigeVariante() {
    const v = varianteSuchen();
    const knopf = $('#rein'), unten = $('#rein-unten'), preis = $('#preis'), pu = $('#preis-unten'), feld = $('#variante');
    if (!v) { if (knopf) { knopf.disabled = true; knopf.textContent = T.nicht_verfuegbar; } return; }
    if (feld) feld.value = v.id;
    if (preis) preis.innerHTML = `${v.compare_at_price > v.price ? `<s>${geld(v.compare_at_price)}</s> ` : ''}${geld(v.price)}<small>${T.produkt_inkl_mwst}</small>`;
    if (pu) pu.textContent = geld(v.price);
    [knopf, unten].forEach((k) => { if (k) { k.disabled = !v.available; k.textContent = v.available ? T.in_den_warenkorb : T.ausverkauft; } });
    const lager = $('#lager'); if (lager) { lager.classList.toggle('aus', !v.available); const sp = $('span', lager); if (sp) sp.textContent = v.available ? T.auf_lager : T.ausverkauft; }
    if (v.featured_media) zeigeMedia(v.featured_media.id);
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
  }
  if (art) {
    try { produkt = JSON.parse(art.dataset.produkt); } catch (e) {}
    gAnzahl = $$('.g-bild').length;
    const bahn = $('#g-bahn');
    if (bahn) bahn.addEventListener('scroll', () => { const i = Math.round(bahn.scrollLeft / bahn.clientWidth); if (i !== gJetzt && i >= 0 && i < gAnzahl) markiere(i); }, { passive: true });
    // Zuletzt angesehen
    const handle = art.dataset.handle, gesehen = lies('bf-gesehen', []).filter((h) => h !== handle);
    schreib('bf-gesehen', [handle, ...gesehen].slice(0, 9));
    const zb = $('#zuletzt');
    if (zb && gesehen.length) {
      Promise.all(gesehen.slice(0, 4).map((h) => fetch(`${root}/products/${h}.js`).then((r) => r.ok ? r.json() : null).catch(() => null))).then((ps) => {
        const gut = ps.filter(Boolean);
        if (!gut.length) return;
        $('#zuletzt-raster').innerHTML = gut.map((p) => `<a class="karte blau" href="${p.url}"><div class="karte-bild">${p.featured_image ? `<img src="${p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_350x350$1$2')}" alt="${p.title}" loading="lazy">` : ''}</div><h3>${p.title}</h3><p class="preis">${geld(p.price)}</p></a>`).join('');
        zb.hidden = false;
      });
    }
    // Empfehlungen nachladen (Section Rendering)
    const emp = $('.empfehlungen');
    if (emp && !emp.innerHTML.trim()) fetch(emp.dataset.url).then((r) => r.text()).then((html) => { const d = document.createElement('div'); d.innerHTML = html; const inner = $('.empfehlungen', d); if (inner) emp.innerHTML = inner.innerHTML; }).catch(() => {});
    // Untere Kaufleiste
    const unten = $('#unten-kauf'), kauf = $('#kauf');
    const pruefeUnten = () => { if (!unten || !kauf) return; const r = kauf.getBoundingClientRect(); unten.classList.toggle('da', r.bottom < 0); };
    window.addEventListener('scroll', pruefeUnten, { passive: true }); pruefeUnten();
    const form = $('#kauf-form');
    if (form) form.addEventListener('submit', async (e) => { e.preventDefault(); const v = varianteSuchen(); if (!v || !v.available) return; await rein(v.id, +$('#menge').textContent || 1, e.submitter || $('#rein')); });
  }

  // Suche mit Elternwörtern
  const SYNONYME = { liege: 'wickelauflage', wickelliege: 'wickelauflage', wickeltisch: 'wickelauflage', kissen: 'kissen', windel: 'wickel', spucktuch: 'mulltuch', mullwindel: 'mulltuch', latz: 'lätzchen', nuckel: 'schnuller', pulli: 'pullover', buggy: 'kinderwagen', wagen: 'kinderwagen', taufe: 'geschenk', geburt: 'geschenk', erstausstattung: 'set', stillen: 'still', schwanger: 'schwanger', neugeboren: 'body', lampe: 'nachtlicht', licht: 'nachtlicht' };
  let sucheTimer = null;
  async function maleSuche(q) {
    const box = $('#suche-ergebnis'); if (!box) return;
    const chips = (box.dataset.chips || '').split(',').filter(Boolean);
    const roh = q.trim().toLowerCase();
    if (!roh) { box.innerHTML = `<div class="chips">${chips.map((c) => `<button type="button" data-such="${c}">${c}</button>`).join('')}</div>`; return; }
    const wort = roh.split(/\s+/).map((w) => SYNONYME[w] || w).join(' ');
    try {
      const r = await fetch(`${BF.suche || root + '/search'}/suggest.json?q=${encodeURIComponent(wort)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`).then((x) => x.json());
      const ps = (r.resources && r.resources.results && r.resources.results.products) || [];
      box.innerHTML = ps.length
        ? `<p class="zahl" style="padding:0 0 12px">${tx('treffer', ps.length)}</p><div class="raster">${ps.map((p) => `<a class="karte blau" href="${p.url}"><div class="karte-bild">${p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}" alt="${p.title}" loading="lazy">` : ''}</div><h3>${p.title}</h3><p class="preis">${geld(Math.round(parseFloat(p.price) * 100))}</p></a>`).join('')}</div><p style="padding:14px 0"><a class="link" href="${BF.suche || root + '/search'}?q=${encodeURIComponent(roh)}&type=product">${T.alle_treffer}</a></p>`
        : `<p class="leer">${tx('nichts_fuer', roh.replace(/[<>&"]/g, ''))}</p><div class="chips">${chips.map((c) => `<button type="button" data-such="${c}">${c}</button>`).join('')}</div>`;
    } catch (e) { box.innerHTML = `<p class="leer">${T.suche_fehler}</p>`; }
  }

  // Knöpfe
  const mAuf = $('#menue-auf'); if (mAuf) mAuf.onclick = () => auf('menue');
  const sAuf = $('#suche-auf'); if (sAuf) sAuf.onclick = () => auf('suche');
  const kAuf = $('#korb-auf'); if (kAuf) kAuf.onclick = async (e) => { if (!$('#korb')) return; e.preventDefault(); if (!korb) await ladeKorb(); await maleKorb(); auf('korb'); };
  const sch = $('#schleier'); if (sch) sch.onclick = alleZu;
  const sf = $('#suche-feld'); if (sf) sf.oninput = (e) => { clearTimeout(sucheTimer); sucheTimer = setTimeout(() => maleSuche(e.target.value), 220); };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') alleZu(); });
  document.addEventListener('submit', async (e) => {
    if (e.target.id === 'code-form') {
      e.preventDefault(); const c = $('#code-feld').value.trim().toUpperCase(); if (!c) return;
      try {
        korb = await post(root + '/cart/update.js', { discount: c });
        const d = (korb.discount_codes || []).find((x) => String(x.code).toUpperCase() === c);
        if (d && d.applicable) { codeGemerkt = c; codeFehler = false; } else { codeFehler = true; korb = await post(root + '/cart/update.js', { discount: '' }); codeAusKorb(); }
      } catch (err) { codeFehler = true; }
      zeigeZahl(); await maleKorb();
    }
  });
  // Passt gut zusammen: Summe neu rechnen, alle zusammen in den Warenkorb
  document.addEventListener('change', (e) => {
    if (!e.target.matches('[data-set]')) return;
    const summe = $$('[data-set]:checked, [data-set-haupt]').reduce((a, c) => a + (+c.dataset.preis || 0), 0);
    const z = $('#set-summe'); if (z) z.textContent = geld(summe);
  });
  document.addEventListener('change', async (e) => {
    if (e.target.id === 'geschenk') { korb = await post(root + '/cart/update.js', { attributes: { Geschenk: e.target.checked ? 'ja' : '' } }); }
  });
  document.addEventListener('click', async (e) => {
    const t = e.target;
    const r = t.closest('[data-rein]'); if (r) { e.preventDefault(); await rein(r.dataset.rein, 1, r); return; }
    const z = t.closest('[data-zeile]'); if (z) { e.preventDefault(); if ($('#korb-form') && !t.closest('#korb')) { await setze(+z.dataset.zeile, +z.dataset.n); location.reload(); } else await setze(+z.dataset.zeile, +z.dataset.n); return; }
    if (t.closest('[data-code-weg]')) { try { korb = await post(root + '/cart/update.js', { discount: '' }); } catch (err) {} codeGemerkt = ''; codeFehler = false; zeigeZahl(); await maleKorb(); return; }
    const such = t.closest('[data-such]'); if (such) { $('#suche-feld').value = such.dataset.such; maleSuche(such.dataset.such); return; }
    const gp = t.closest('[data-g]'); if (gp) { zeigeBild(gJetzt + +gp.dataset.g); return; }
    const gb = t.closest('[data-bild]'); if (gb) { zeigeBild(+gb.dataset.bild); if (gb.hasAttribute('data-hoch')) window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if (t.closest('#mehr')) { $('#menge').textContent = Math.min(9, +$('#menge').textContent + 1); return; }
    if (t.closest('#weniger')) { $('#menge').textContent = Math.max(1, +$('#menge').textContent - 1); return; }
    const fb = t.closest('[data-farbe]'); if (fb) { const c = fb.parentElement; $$('button', c).forEach((b) => b.classList.toggle('an', b === fb)); const fn = $('#farbe-name'); if (fn) fn.textContent = fb.dataset.farbe; zeigeMedia(fb.dataset.mediaId); zeigeVariante(); return; }
    const gr = t.closest('[data-gr]'); if (gr) { const c = gr.parentElement; $$('button', c).forEach((b) => b.classList.toggle('an', b === gr)); zeigeVariante(); return; }
    if (t.closest('#set-rein')) {
      const haupt = varianteSuchen(), items = [];
      if (haupt && haupt.available) items.push({ id: haupt.id, quantity: 1 });
      $$('[data-set]:checked').forEach((c) => items.push({ id: +c.dataset.set, quantity: 1 }));
      if (!items.length) return;
      await reinAlle(items, t.closest('#set-rein')); return;
    }
    if (t.closest('#rein-unten')) { const v = varianteSuchen(); if (v && v.available) await rein(v.id, +$('#menge').textContent || 1, t.closest('#rein-unten')); return; }
    const zu = t.closest('[data-zu]'); if (zu) { if (zu.tagName === 'BUTTON') e.preventDefault(); alleZu(); }
  });

  // Startvideo: läuft sofort (autoplay im HTML), außerhalb des Bildschirms angehalten, bei „weniger Bewegung“ Standbild
  const vid = $('.start-video');
  if (vid) {
    const spiel = () => { const p = vid.play(); if (p && p.catch) p.catch(() => {}); };
    if (ruhig()) { vid.removeAttribute('autoplay'); vid.pause(); }
    else {
      spiel();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) spiel(); });
      window.addEventListener('touchstart', spiel, { once: true, passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) spiel(); else vid.pause(); })).observe(vid);
    }
  }

  // Größen, die nur aus Zahlen bestehen (59, 66, 73 …), immer aufsteigend zeigen – egal in welcher Reihenfolge der Lieferant sie angelegt hat
  $$('.groessen').forEach((c) => {
    const b = $$('[data-gr]', c);
    if (b.length > 1 && b.every((x) => /^\d+(?:[.,]\d+)?$/.test(x.dataset.gr.trim()))) b.sort((x, y) => parseFloat(x.dataset.gr.replace(',', '.')) - parseFloat(y.dataset.gr.replace(',', '.'))).forEach((x) => c.appendChild(x));
  });

  ladeKorb().catch(() => {});
})();
